<template>
  <component :is="component" />
</template>

<script>
import groupBuyOrderCheck from '../components/groupBuyOrderCheck.vue'
import groupBuyOrderEdit from '../groupBuyOrderEdit.vue'
export default {
  components: {
    groupBuyOrderCheck,
    groupBuyOrderEdit
  },
  data() {
    return {
      component: 'groupBuyOrderCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'groupBuyOrderCheck' : 'groupBuyOrderEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order-manage/check/groupBuyOrderCheck.vue